<template>
	<TeamListCardLayout :class="classes">
		<template v-slot:name>
			<label class="team-list-header-card__column-label">
				{{ $t( "common.TeamListHeaderCard_nameColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:leads>
			<label class="team-list-header-card__column-label">
				{{ $t( "common.TeamListHeaderCard_leadsColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:members>
			<label class="team-list-header-card__column-label">
				{{ $t( "common.TeamListHeaderCard_membersColumnHeader" ) }}
			</label>
		</template>
	</TeamListCardLayout>
</template>

<script>
import TeamListCardLayout from "./TeamListCardLayout";

export default {
	name: "TeamListHeaderCard",
	components: {
		TeamListCardLayout,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"team-list-header-card": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.team-list-header-card {
	height: 1.875rem;
}

.team-list-header-card__column-label {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $team-list-header-card-column-label-color;
}
</style>
